const darkColors = ['gray', 'neutral'] as const
const brightColors = ['sky', 'cyan', 'lime', 'yellow', 'amber'] as const

export const regularColors = [
  'red',
  'orange',
  'green',
  'emerald',
  'teal',
  'blue',
  'indigo',
  'violet',
  'purple',
  'fuchsia',
  'pink',
  'rose',
] as const

export const baseColors = [...regularColors, ...brightColors] as const
const colors = [...baseColors, ...darkColors]
export type Color = (typeof colors)[number]
